import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-12 min-w-min 2xl:w-2/3 3xl:w-3/5"
}

import { Form } from "vee-validate";
import { ref } from "vue";
import { NavigationGuard, onBeforeRouteLeave, onBeforeRouteUpdate } from "vue-router";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { useProjectDurationSettings } from "shared/composables/projectDurationSettings";
import { useSaveBeforeLeaveConfirmationModal } from "shared/composables/toast";
import NonWorkingDays from "@/components/working_days/NonWorkingDays.vue";
import { useLoadCurrentProject } from "@/composables/project";
import WorkingHours from "@/views/settings_project/components/WorkingHours.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabDurations',
  setup(__props) {

const { projectDurationSettings, isProjectDurationSettingsLoading } = useProjectDurationSettings();
const { project, isProjectLoading } = useLoadCurrentProject();
const showSaveBeforeLeaveConfirmationModal = useSaveBeforeLeaveConfirmationModal();

const workingHoursRef = ref<{ form: typeof Form | null } | null>(null);
const nonWorkingDaysRef = ref<{ form: typeof Form | null } | null>(null);

const isDirty = () => {
  const workingHoursFormMeta = workingHoursRef.value?.form?.meta;
  const nonWorkingDaysFormMeta = nonWorkingDaysRef.value?.form?.meta;
  return workingHoursFormMeta?.dirty || nonWorkingDaysFormMeta?.dirty;
};

const navigationGuard: NavigationGuard = (to, from, next) => {
  if (!isDirty()) {
    return next();
  }
  showSaveBeforeLeaveConfirmationModal().then((confirmed) => {
    if (confirmed) {
      next();
    }
  });
};

onBeforeRouteLeave(navigationGuard);
onBeforeRouteUpdate(navigationGuard);

return (_ctx: any,_cache: any) => {
  return (_unref(isProjectDurationSettingsLoading) || _unref(isProjectLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner)
      ]))
    : (_unref(projectDurationSettings) && _unref(project))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(WorkingHours, {
            ref_key: "workingHoursRef",
            ref: workingHoursRef,
            projectDurationSettings: _unref(projectDurationSettings)
          }, null, 8, ["projectDurationSettings"]),
          _createVNode(NonWorkingDays, {
            ref_key: "nonWorkingDaysRef",
            ref: nonWorkingDaysRef,
            projectDurationSettings: _unref(projectDurationSettings),
            project: _unref(project)
          }, null, 8, ["projectDurationSettings", "project"])
        ]))
      : _createCommentVNode("", true)
}
}

})